import { toAbsoluteUrl } from "../../../_metronic/helpers"

export const Header = () => {
  return (
    <div id="kt_app_header" className="app-header">
      <div id="kt_app_header_container"
        className="app-container flex-lg-grow-1 d-flex align-items-stretch justify-content-between">
        <div className="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show sidebar menu">
          <div className="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_sidebar_mobile_toggle"><i
            className="ki-duotone ki-abstract-14  fs-1"><span className="path1"></span><span className="path2"></span></i></div>
          <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0"><a className="d-lg-none" href="/inicio">
            <img alt="Logo" src="/media/logos/logo_amsm.png" className="h-30px" /></a></div>
        </div>
        <div id="kt_app_header_wrapper" className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
          <div className="app-header-menu app-header-mobile-drawer align-items-stretch" data-kt-drawer="true"
            data-kt-drawer-name="app-header-menu" data-kt-drawer-activate="{default: true, lg: false}"
            data-kt-drawer-overlay="true" data-kt-drawer-width="225px" data-kt-drawer-direction="end"
            data-kt-drawer-toggle="#kt_app_header_menu_toggle" data-kt-swapper="true"
            data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
            data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}">
            <div className="menu menu-rounded menu-column menu-lg-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0" id="kt_app_header_menu" data-kt-menu="true"
            ><a href="/inicio">
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/logo_default.png')}
                className='h-50px app-sidebar-logo-default theme-light-show'
                style={{padding: '5px'}}
              /></a>
            </div>
          </div>
          <div className="menu-item me-lg-1" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span className="fw-bold fs-2 mb-1 text-primaryamsm" id="titlepage">Noticias</span>
          </div>

        </div>
      </div>
    </div>
  )
}
